
/**
 * Centralized Branding Configuration
 * Change the name and logo path here to update them throughout the application.
 */

export const BRANDING = {
    name: 'Full Solution',
    logo: process.env.PUBLIC_URL + '/logoonly.png',
    footerText: '2014-' + new Date().getFullYear() + ' Full Solution, LLC. All rights reserved.',
    favicon: process.env.PUBLIC_URL + '/logoonly.png'
};

export default BRANDING;
